import { memo, useMemo } from 'react';
import { ReactComponent as HeartOutline } from '@assets/icons/heart-outline.svg';
import { ReactComponent as MapIcon } from '@assets/icons/map-marker-alt.svg';
import { ReactComponent as Star } from '@assets/icons/star-outline.svg';

import { Flex, FlexProps, useTheme } from '@chakra-ui/react';

import { Button, Text } from 'ui';

interface LocationTilesProps extends FlexProps {
  isLogged: boolean;
  isHomeLocationsExist: boolean;
  onLocation: () => void;
  onFavorites: () => void;
  onNearMe: () => void;
}

const LocationTiles = ({
  isLogged,
  isHomeLocationsExist,
  onLocation,
  onFavorites,
  onNearMe,
  ...props
}: LocationTilesProps) => {
  const {
    colors: {
      palette: {
        components: { locations: styles }
      }
    }
  } = useTheme();

  const tiles = useMemo(() => {
    const array = [
      {
        label: 'My Favorites',
        Icon: HeartOutline,
        onClick: onFavorites
      },
      {
        label: 'Near Me',
        Icon: MapIcon,
        onClick: onNearMe
      }
    ];

    if (isLogged || isHomeLocationsExist) {
      array.unshift({
        label: 'My Location',
        Icon: Star,
        onClick: onLocation
      });
    }

    return array;
  }, [isLogged, isHomeLocationsExist, onFavorites, onNearMe, onLocation]);

  return (
    <Flex w='full' gap={{ base: '10px', md: '15px' }} {...props}>
      {tiles.map(({ label, Icon, onClick }) => (
        <Button
          key={label}
          onClick={onClick}
          as={Flex}
          flexDirection='column'
          p={5}
          borderRadius='12px'
          h={{ base: 'auto', md: '133px' }}
          gap={{ base: '5px', md: '15px' }}
          bg={styles.tileBg}
          cursor='pointer'
          justifyContent={{ base: 'flex-start', md: 'center' }}
          sx={{
            svg: {
              width: { base: '24px', md: '40px' },
              height: { base: '24px', md: '40px' }
            }
          }}
        >
          <Icon height={40} fill={styles.tileColor} />
          <Text
            fontWeight='semibold'
            fontSize={{ base: '14px', md: '25px' }}
            textTransform='none'
            color={styles.tileColor}
          >
            {label}
          </Text>
        </Button>
      ))}
    </Flex>
  );
};

export default memo(LocationTiles);
